/* eslint-disable react-native/no-inline-styles */
import React, { useEffect, useRef, useState } from 'react';
import { useFormikContext } from 'formik';
import {
  View,
  StyleSheet,
  Dimensions,
  Alert as AlertNotif,
} from 'react-native';
import Toast from 'react-native-toast-message';
import { useDispatch, useSelector } from 'react-redux';

import * as Yup from 'yup';

import ModalFull from '@components/modal/ModalFull';
import SociollaText from '@components/sociolla/SociollaText';
import {
  SociollaInput,
  SociollaSelectBox,
  SociollaSubmitButton,
  SociollaMapPicker,
  SociollaForm,
} from '@components/sociolla/form';
import * as Layout from '@components/screen/Layout';
import ItemDetail from '@components/global/ItemDetail';
import Image from '@components/global/Image';
import Alert from '@/components/global/Alert';
import TimePicker from '@components/form/TimePicker';
import CheckBox from '@components/form/CheckBox';
import ToggleSwitch from '@components/form/Toggle';

import Colors from '@global/colors';
import { isWeb, isNative } from '@global/screens';
import {
  checkDetailAddress,
  findMatchValue,
  formatTimeWithAMPM,
  isVn,
  defaultCountry,
} from '@global/helpers';
import { buttonRounded } from '@/assets/styles/buttonStyles';
import { getAllStates, getAllCities, getAllDistricts } from '@api/ms-account';
import { showAlert } from '@/store/global';
import PropTypes from 'prop-types';

const AddressToggle = ({ label, value }) => {
  const { values, setFieldValue } = useFormikContext();
  return (
    <Layout.FormGroup>
      <SociollaText style={{ fontSize: 14, marginBottom: 8 }}>
        {label}
      </SociollaText>
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <ToggleSwitch
          size="small"
          value={!!values[value]}
          onValueChange={(val) => setFieldValue(value, val)}
        />
        <SociollaText style={{ fontSize: 14, marginLeft: 10 }}>
          {values[value] ? 'Yes' : 'No'}
        </SociollaText>
      </View>
    </Layout.FormGroup>
  );
};
AddressToggle.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
};

const propTypes = {
  testID: PropTypes.string,
  state: PropTypes.object,
  addressType: PropTypes.string,
  data: PropTypes.object,
  onSubmit: PropTypes.func,
  onTogglePremium: PropTypes.func,
  onClose: PropTypes.func,
  view: PropTypes.bool,
  edit: PropTypes.bool,
  show: PropTypes.bool,
  modalType: PropTypes.string,
};

const dimension = Dimensions.get('window');

let form = null;

const ModalAddress = (props) => {
  const dispatch = useDispatch();
  const isView = props.view ?? false;

  let textTitle;
  let formValue;

  const optionDays = [
    { value: 'anytime', list_day: 'Anytime' },
    { value: 1, list_day: 'Monday' },
    { value: 2, list_day: 'Tuesday' },
    { value: 3, list_day: 'Wednesday' },
    { value: 4, list_day: 'Thursday' },
    { value: 5, list_day: 'Friday' },
    { value: 6, list_day: 'Saturday' },
    { value: 7, list_day: 'Sunday' },
  ];

  switch (props.modalType) {
    case 'delivery':
      textTitle = 'Delivery';
      break;
    case 'invoice':
      textTitle = 'Invoice';
      break;
    case 'npwp':
      textTitle = 'Tax Identification Number';
      break;
    case 'store':
      textTitle = 'Store';
      break;
    default:
      textTitle = 'Identification Number';
      break;
  }

  const defaultFormValue = {
    name: props.modalType === 'invoice' ? 'INV ' : '',
    street: '',
    street2: '',
    state: '',
    city: '',
    country: '',
    district: '',
    postal_code: '',
  };

  const nonIdentityForm = {
    ...defaultFormValue,
    image: '',
    email: '',
    phone: '',
    mobile: '',
    notes: '',
  };

  const invoiceForm = {
    ...nonIdentityForm,
    from_time: '',
    to_time: '',
    list_day: [],
  };

  const deliveryForm = {
    ...nonIdentityForm,
    contact_person: '',
    store_code: '',
    lat_long: '',
    is_premium: false,
    is_consignment: false,
  };

  const storeForm = {
    name: '',
    street: '',
    street2: '',
    state: '',
    city: '',
    country: '',
    district: '',
    postal_code: '',
    store_code: '',
    lat_long: '',
    is_premium: false,
  };

  switch (props.modalType) {
    case 'delivery':
      formValue = deliveryForm;
      break;
    case 'invoice':
      formValue = invoiceForm;
      break;
    case 'ktp':
      formValue = { ...defaultFormValue, ktp: '' };
      break;
    case 'store':
      formValue = storeForm;
      break;
    default:
      formValue = { ...defaultFormValue, vat: '' };
      break;
  }

  const countries = useSelector((state) => state.resources.countries);
  const delivery = useSelector((state) => state.customer.delivery_address);
  const ktp = useSelector((state) => state.customer.ktp_address);
  const npwp = useSelector((state) => state.customer.npwp_address);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [loading, setLoading] = useState(true);
  const [premiumToggling, setPremiumToggling] = useState(false);
  const [country, setCountry] = useState();
  const [initialValue, setInitialValue] = useState(formValue);
  const [type] = useState(props.modalType ?? '');
  const [enableCity, setEnableCity] = useState(false);
  const [title, setTitle] = useState(`Add ${textTitle} Address`);
  const [city, setCity] = useState('');
  const [districts, setDistricts] = useState([]);
  const [enableDistrict, setEnableDistrict] = useState(false);
  const [selectedDistrictPinCodes, setSelectedDistrictPinCodes] = useState([]);
  const [sameAsKtp, setSameAsKtp] = useState(false);
  const [sameAsNpwp, setSameAsNpwp] = useState(false);

  const isNotIdentity = type !== 'ktp' && type !== 'npwp';
  const hasKtpAddress = Object.keys(ktp || {}).length > 0;
  const hasNpwpAddress = Object.keys(npwp || {}).length > 0;
  const showSameAsKtpCheckbox = !isVn() && type !== 'ktp' && hasKtpAddress;
  const showSameAsNpwpCheckbox = !isVn() && type !== 'npwp' && hasNpwpAddress;

  const defaultAddressValidation = {
    name: Yup.string().required('Name is required').label('Name'),
    street: Yup.string().required('Street is required').label('Street'),
    street2: Yup.string().label('Street 2'),
    state: Yup.object().required('State is required').label('State'),
    city: Yup.mixed().required('City is required').label('City'),
    country: Yup.object().label('Country'),
    district: isVn()
      ? Yup.mixed().label('District')
      : Yup.mixed().required('District is required').label('District'),
    postal_code: isVn()
      ? Yup.string().nullable().notRequired().label('ZIP Code')
      : Yup.string()
          .required('ZIP code is required')
          .matches(/^\d{5}$/, 'ZIP code must be a 5 digit number')
          .label('ZIP Code'),
  };

  const storeAddressValidation = Yup.object().shape({
    name: Yup.string().required('Name is required').label('Name'),
    street: Yup.string().required('Street is required').label('Street'),
    street2: Yup.string().label('Street 2'),
    state: Yup.object().required('State is required').label('State'),
    city: Yup.mixed().required('City is required').label('City'),
    country: Yup.object().label('Country'),
    district: isVn()
      ? Yup.mixed().label('District')
      : Yup.mixed().required('District is required').label('District'),
    postal_code: isVn()
      ? Yup.string().nullable().notRequired().label('ZIP Code')
      : Yup.string()
          .required('ZIP code is required')
          .matches(/^\d{5}$/, 'ZIP code must be a 5 digit number')
          .label('ZIP Code'),
    store_code: Yup.string()
      .required('Store Code is required')
      .label('Store Code'),
    lat_long: Yup.mixed().label('Location'),
  });

  const nonIdentityValidation = {
    contact_person: Yup.string()
      .required('Contact Person is required')
      .label('Contact Person')
      .when('address_type', (address_type) => {
        if (address_type === 'delivery') {
          return Yup.string()
            .required('Contact Person is required')
            .label('Contact Person');
        } else {
          return Yup.string().label('Contact Person');
        }
      }),
    phone: Yup.string()
      .matches(new RegExp('[0-9]{5}'), 'Must be a valid phone')
      .label('Phone'),
    mobile: Yup.string()
      .required('Mobile is required')
      .matches(new RegExp('[0-9]{8}'), 'Must be a valid mobile')
      .label('Phone'),
    email: Yup.string().email('Must be a valid email'),
    notes: Yup.string().label('Notes'),
    market_type: Yup.object().label('Market Type'),
    business_type: Yup.mixed().label('Business Type'),
    address_type: Yup.string().label('Address Type'),
    lat_long: Yup.mixed().label('Location'),
  };

  const validationAddress = Yup.object().shape({
    ...defaultAddressValidation,
    ...nonIdentityValidation,
    ...(props.modalType === 'invoice' && {
      from_time: Yup.string()
        .required('From Time is required')
        .when('list_day', (list_day) => {
          if (!(list_day || []).some((l) => l.value == 'anytime')) {
            return Yup.string().required('From Time is required');
          } else {
            return Yup.string();
          }
        }),
      to_time: Yup.string()
        .required('To Time is required')
        .when('list_day', (list_day) => {
          if (!(list_day || []).some((l) => l.value == 'anytime')) {
            return Yup.string().required('To Time is required');
          } else {
            return Yup.string();
          }
        }),
      list_day: Yup.array().min(1, 'Select at least one day'),
    }),
  });

  const ktpValidationAddress = {
    ktp: Yup.string()
      .required(isVn() ? 'ID is required' : 'KTP is required')
      .matches(
        isVn() ? /^[0-9]+$/ : /^\d{16}$/,
        isVn()
          ? 'ID should contain numbers only'
          : 'KTP should contain numbers only',
      )
      .test(
        'valid-length',
        isVn()
          ? 'ID cannot be empty'
          : 'Identification Number must be exactly 16 digits',
        (value) => {
          if (!value) {
            return false;
          }

          if (isVn()) {
            return value.length > 0;
          } else {
            return value.length === 16;
          }
        },
      )
      .label(isVn() ? 'ID' : 'KTP'),
  };

  const npwpValidationAddress = {
    vat: !isVn()
      ? Yup.string()
          .required('NPWP is required')
          .matches(/^\d{16}$/, 'NPWP must be a 16 digit number')
          .label('NPWP')
      : Yup.string().required('Tax ID is required').label('Tax ID'),
  };

  const isKTPAddress = type === 'ktp';

  const validationIdentityAddress = Yup.object().shape({
    ...defaultAddressValidation,
    ...(isKTPAddress ? ktpValidationAddress : npwpValidationAddress),
  });

  const validationForm =
    type === 'store'
      ? storeAddressValidation
      : isNotIdentity
      ? validationAddress
      : validationIdentityAddress;

  const onChangeState = async (states) => {
    if (form) {
      await form.setFieldValue('city', '', true);
      setEnableCity(true);
    }
    if (states?.id || states?._id) {
      getAllCities({
        params: {
          filter: {
            state_id: states?._id || states?.id || '',
          },
        },
      }).then((res) => {
        const strCity = props.data.city && props.edit ? props.data.city : city;
        let selectedCity = null;
        if (strCity) {
          selectedCity = checkDetailAddress(res.data.data, strCity);
          if (selectedCity) {
            if (form) {
              form.setFieldValue('city', selectedCity);
            } else {
              setInitialValue({
                ...initialValue,
                city: selectedCity,
              });
            }
          }
        }
        setCity('');
        setCities(res.data.data);
        if (selectedCity) {
          onChangeCity(selectedCity);
        }
      });
    }
  };

  const resolveDistrictMatch = (fetchedDistricts, districtRef, postalCode) => {
    if (!districtRef) {
      return null;
    }

    const refId = districtRef.id || districtRef._id;
    if (refId) {
      const matched = fetchedDistricts.find((d) => d._id === refId);
      if (matched) {
        return matched;
      }
    }

    const refName = districtRef.name;
    if (refName) {
      const nameMatched = fetchedDistricts.find(
        (d) => d.name?.toLowerCase() === refName.toLowerCase(),
      );
      if (nameMatched) {
        return nameMatched;
      }
    }

    if (postalCode) {
      const candidates = fetchedDistricts.filter((d) =>
        (d.pin_codes || []).includes(String(postalCode)),
      );
      if (candidates.length === 1) {
        return candidates[0];
      }
    }

    return null;
  };

  const onChangeCity = async (selectedCity) => {
    if (form) {
      await form.setFieldValue('district', '', true);
      await form.setFieldValue('postal_code', '');
    }
    setSelectedDistrictPinCodes([]);
    setEnableDistrict(true);
    if (isVn() || !(selectedCity?.id || selectedCity?._id)) {
      return;
    }
    getAllDistricts({
      params: {
        filter: { city_id: selectedCity._id || selectedCity.id },
        sort: JSON.stringify({ name: 1 }),
      },
    }).then((res) => {
      const fetchedDistricts = res.data.data || [];
      setDistricts(fetchedDistricts);

      if (!props.edit) {
        return;
      }

      const matched = resolveDistrictMatch(
        fetchedDistricts,
        props.data?.district,
        props.data?.postal_code,
      );
      if (!matched) {
        return;
      }

      form?.setFieldValue('district', matched);
      setSelectedDistrictPinCodes(matched.pin_codes || []);
      if (
        props.data?.postal_code &&
        (matched.pin_codes || []).includes(String(props.data.postal_code))
      ) {
        form?.setFieldValue('postal_code', String(props.data.postal_code));
      }
    });
  };

  const autofillRequestRef = useRef(0);

  const applyAddressAutofill = async (
    source,
    { identityTargetField, identitySourceValue } = {},
  ) => {
    const requestId = ++autofillRequestRef.current;
    const isStale = () => autofillRequestRef.current !== requestId;

    if (!source || !form) {
      return;
    }

    form.setFieldValue('name', source.name || '');
    form.setFieldValue('street', source.street || '');
    form.setFieldValue('street2', source.street2 || '');
    form.setFieldValue('postal_code', source.postal_code || '');

    if (identityTargetField) {
      form.setFieldValue(identityTargetField, identitySourceValue || '');
    }

    if (source.country) {
      form.setFieldValue('country', source.country);
    }

    form.setFieldValue('city', '');
    form.setFieldValue('district', '');
    setSelectedDistrictPinCodes([]);

    if (!source.state) {
      form.setFieldValue('state', '');
      setCities([]);
      setDistricts([]);
      setEnableCity(false);
      setEnableDistrict(false);
      return;
    }

    const normalizedState = source.state.id
      ? { ...source.state, _id: source.state.id }
      : source.state;
    form.setFieldValue('state', normalizedState);
    setEnableCity(true);

    const stateId = normalizedState._id || normalizedState.id;
    if (!stateId) {
      setCities([]);
      setDistricts([]);
      setEnableDistrict(false);
      return;
    }

    let fetchedCities;
    try {
      const cityRes = await getAllCities({
        params: { filter: { state_id: stateId } },
      });
      fetchedCities = cityRes.data.data || [];
    } catch (err) {
      if (!isStale()) {
        setSameAsKtp(false);
        setSameAsNpwp(false);
      }
      return;
    }
    if (isStale()) {
      return;
    }
    setCities(fetchedCities);

    if (!source.city) {
      setDistricts([]);
      setEnableDistrict(false);
      return;
    }

    const normalizedCity = source.city.id
      ? { ...source.city, _id: source.city.id }
      : source.city;
    const cityId = normalizedCity._id || normalizedCity.id;
    const matchedCity =
      fetchedCities.find((c) => c._id === cityId) || normalizedCity;
    form.setFieldValue('city', matchedCity);
    setEnableDistrict(true);

    if (!cityId) {
      return;
    }

    let fetchedDistricts;
    try {
      const districtRes = await getAllDistricts({
        params: {
          filter: { city_id: cityId },
          sort: JSON.stringify({ name: 1 }),
        },
      });
      fetchedDistricts = districtRes.data.data || [];
    } catch (err) {
      if (!isStale()) {
        setSameAsKtp(false);
        setSameAsNpwp(false);
      }
      return;
    }
    if (isStale()) {
      return;
    }
    setDistricts(fetchedDistricts);

    if (!source.district) {
      return;
    }

    const matchedDistrict = resolveDistrictMatch(
      fetchedDistricts,
      source.district,
      source.postal_code,
    );
    if (matchedDistrict) {
      form.setFieldValue('district', matchedDistrict);
      setSelectedDistrictPinCodes(matchedDistrict.pin_codes || []);
    }
  };

  const clearAutofilledAddress = (identityTargetField) => {
    autofillRequestRef.current += 1;

    if (!form) {
      return;
    }

    form.setFieldValue('name', '');
    form.setFieldValue('street', '');
    form.setFieldValue('street2', '');
    form.setFieldValue('postal_code', '');
    form.setFieldValue('state', '');
    form.setFieldValue('city', '');
    form.setFieldValue('district', '');

    if (identityTargetField) {
      form.setFieldValue(identityTargetField, '');
    }

    setCities([]);
    setDistricts([]);
    setSelectedDistrictPinCodes([]);
    setEnableCity(false);
    setEnableDistrict(false);
  };

  const onCurrentLocation = (data) => {
    const cn = checkDetailAddress(countries, data.address?.country || '');
    const state = checkDetailAddress(states, data.address?.state || '');
    if (cn) {
      form.setFieldValue('country', cn);
    }
    if (state) {
      form.setFieldValue('state', state);
    }
  };

  const renderDayValue = (data) => {
    if (!data?.list_day) {
      return '-';
    }
    const hasAnytime = data.list_day.some((val) => val.list_day === 'Anytime');
    if (hasAnytime) {
      return 'Anytime';
    }
    return data.list_day.map((val) => val.list_day).join(', ');
  };

  const renderTimeValue = (data) => {
    if (!data?.from_time || !data?.to_time) {
      return '-';
    }
    return `From ${formatTimeWithAMPM(
      data.from_time,
    )} | To ${formatTimeWithAMPM(data.to_time)}`;
  };

  const handleSubmit = async (data, { resetForm }) => {
    const payload = { ...data };
    const address_type = props.addressType ? props.addressType : type;

    if (type === 'delivery') {
      if (!payload?.contact_person) {
        Toast.show({
          text1: 'PIC is required',
          type: 'error',
        });

        return;
      }
    }

    try {
      const cn = countries.find(
        (x) => x.name.toLowerCase() === defaultCountry(),
      );
      const state = checkDetailAddress(states, data?.state?.name || '');

      if (type === 'delivery') {
        payload.market_type = {
          id: data.market_type.id,
          code: data.market_type.code,
          cerebro_id: data.market_type.cerebro_id || '',
          business_type: data.market_type.business_type,
        };
        payload.store_code = data.store_code;
        delete payload.business_type;
      }

      payload.country = {
        name: cn.name,
        id: cn._id,
        cerebro_id: cn.odoo_country_id || '',
      };
      payload.state = {
        name: state?.name ? state.name : data.state.name,
        id: state?.id
          ? state.id
          : state?._id
          ? state._id
          : data.state.id
          ? data.state.id
          : data.state._id,
        cerebro_id: state?.odoo_state_id
          ? state.odoo_state_id
          : data.state.odoo_state_id
          ? data.state.odoo_state_id
          : '',
      };
      payload.city = {
        id: data.city._id,
        name: data.city.name,
      };

      if (type === 'delivery') {
        const deliveryData = [...delivery];

        const normalizedName = (payload.name || '').trim().toLowerCase();
        const isDuplicateName = deliveryData.some((existing) => {
          const existingName = (existing?.name || '').trim().toLowerCase();
          if (!existingName) {
            return false;
          }

          if (payload._id && existing._id === payload._id) {
            return false;
          }

          if (payload.tempIdx && existing.tempIdx === payload.tempIdx) {
            return false;
          }

          return existingName === normalizedName;
        });

        if (isDuplicateName) {
          if (isNative) {
            AlertNotif.alert('Error', 'Delivery name must be unique');
          } else {
            Toast.show({
              text1: 'Delivery name must be unique',
              type: 'error',
            });
          }
          return;
        }
      }

      await props.onSubmit(payload, address_type);
      resetForm();
      props.onClose();
    } catch (e) {
      console.log(e);
    }
  };

  const onClose = () => {
    if (isView) {
      props.onClose();
      return;
    }
    dispatch(
      showAlert({
        show: true,
        title: 'Discard Address',
        description:
          'Customer address data will not be in saved. Do you want to proceed?',
        onCallback: () => {
          props.onClose();
        },
      }),
    );
  };

  useEffect(() => {
    let isMounted = true;
    if (countries?.length && !isView) {
      const cn = countries.find(
        (x) => x.name.toLowerCase() === defaultCountry(),
      );

      getAllStates({
        params: {
          filter: {
            country_id: cn._id,
          },
        },
      }).then((res) => {
        if (isMounted) {
          setCountry(cn);
          setStates(res.data.data);
          setLoading(false);
        }
      });
    }
    return () => (isMounted = false);
  }, [countries]);

  useEffect(() => {
    let mounted = true;
    if (mounted && !isView) {
      const addressData = {
        ...props.data,
        ...(props.data?.state?.id
          ? {
              state: {
                ...props.data.state,
                _id: props.data.state.id,
              },
            }
          : {}),
        ...(props.data?.city?.id
          ? {
              city: {
                ...props.data.city,
                _id: props.data.city.id,
              },
            }
          : {}),
        ...(props.data?.district?.id
          ? {
              district: {
                ...props.data.district,
                _id: props.data.district.id,
              },
            }
          : {}),
      };

      const initialData = props.edit
        ? { ...initialValue, ...addressData }
        : initialValue;
      if (!isWeb) {
        initialData.address_type = type;
      }

      let getInitialData =
        type === 'delivery'
          ? {
              ...initialData,
              market_type: props.data.market_type || '',
              business_type: props.data.market_type?.business_type || '',
            }
          : initialData;

      if (isVn() && type == 'invoice' && !props?.data?.list_day?.length) {
        getInitialData = {
          ...getInitialData,
          list_day: optionDays,
        };
      }

      setInitialValue(getInitialData);
    }

    let mobileTitle;

    switch (type) {
      case 'npwp':
        mobileTitle = 'NPWP';
        break;
      case 'ktp':
        mobileTitle = 'KTP';
        break;
      case 'delivery':
        mobileTitle = 'Delivery';
        break;
      case 'store':
        mobileTitle = 'Store';
        break;
      default:
        mobileTitle = 'Invoice';
        break;
    }

    if (mounted && props.view) {
      setTitle(`${isWeb ? textTitle : mobileTitle} Address`);
      setLoading(false);
    }
    if (mounted && props.edit) {
      setTitle(`Edit ${textTitle} Address`);
      setEnableCity(true);
      onChangeState(props.data.state);
      setLoading(false);
    }
    return () => (mounted = false);
  }, [props.data]);

  const renderLoading = () => <Layout.Loader />;

  // const renderImageAddress = () => (
  //   <View style={styles.imageAddress}>
  //     <SociollaText style={styles.photoText}>Photo</SociollaText>
  //     <TouchableOpacity
  //       style={{ width: 120, height: 120 }}
  //       onPress={() => {
  //         if (props?.data?.image) {
  //           dispatch(showImage({ isModal: true, url: props.data.image }));
  //         }
  //       }}>
  //       <Image
  //         style={{ width: 120, height: 120 }}
  //         width={120}
  //         height={120}
  //         isResolveAsset
  //         source={props.data?.image ? { uri: props.data.image } : img}
  //       />
  //     </TouchableOpacity>
  //   </View>
  // );

  const handleTogglePremium = async (value) => {
    if (!props.onTogglePremium || premiumToggling) {
      return;
    }
    setPremiumToggling(true);
    try {
      await props.onTogglePremium(props.data, value);
    } finally {
      setPremiumToggling(false);
    }
  };

  const renderViewPremiumToggle = (label) => (
    <ItemDetail
      name={label}
      valueComponent={
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <ToggleSwitch
            size="small"
            value={!!props.data?.is_premium}
            disabled={premiumToggling}
            onValueChange={handleTogglePremium}
          />
          <SociollaText style={{ fontSize: 14, marginLeft: 10 }}>
            {props.data?.is_premium ? 'Yes' : 'No'}
          </SociollaText>
        </View>
      }
    />
  );

  const upperViewDeliveryContent = () => (
    <React.Fragment>
      <ItemDetail
        name="Person in Charge (PIC)"
        value={props.data?.contact_person || '-'}
      />
      {renderViewPremiumToggle('Premium')}
      <ItemDetail
        name="Consignment"
        value={props.data?.is_consignment ? 'Yes' : 'No'}
      />
      {/* <ItemDetail
        name="Market Type"
        value={props.data?.market_type?.code || '-'}
      />
      <ItemDetail
        name="Business Type"
        value={props.data?.market_type?.business_type?.code || '-'}
      /> */}
    </React.Fragment>
  );

  const renderViewAddress = () => (
    <React.Fragment>
      <ItemDetail
        name={isVn() ? 'District Area' : 'City'}
        value={props.data?.city?.name || '-'}
      />
      {!isVn() && (
        <ItemDetail name="District" value={props.data?.district?.name || '-'} />
      )}
      <ItemDetail name="ZIP Code" value={props.data?.postal_code || '-'} />
      <ItemDetail name="Street" value={props.data?.street || '-'} />
      <ItemDetail name="Street 2" value={props.data?.street2 || '-'} />
    </React.Fragment>
  );

  const renderUpperViewAddress = () => (
    <React.Fragment>
      <ItemDetail name="Country ID" value={props.data?.country?.name || '-'} />
      <ItemDetail
        name={isVn() ? 'City ID' : 'State ID'}
        value={props.data?.state?.name || '-'}
      />
      {isNotIdentity && renderViewAddress()}
    </React.Fragment>
  );

  const upperIdentificationNumber = () => (
    <ItemDetail
      name={
        type === 'ktp' ? 'Identification Number' : 'Tax Identification Number'
      }
      value={props.data?.vat || props.data?.ktp || '-'}
    />
  );

  const upperNonStoreViewContent = () => (
    <React.Fragment>
      {!isNotIdentity && upperIdentificationNumber()}
      {type === 'delivery' && upperViewDeliveryContent()}
      {renderUpperViewAddress()}
    </React.Fragment>
  );

  const upperStoreViewContent = () => (
    <React.Fragment>
      <ItemDetail name="Store Code" value={props.data?.store_code || '-'} />
      {renderViewPremiumToggle('Premium Store')}
    </React.Fragment>
  );

  const renderUpperViewContent = () => (
    <React.Fragment>
      <ItemDetail
        name={props.modalType === 'delivery' ? 'Delivery Name' : 'Name'}
        value={props.data?.name || '-'}
      />
      {type !== 'store' && upperNonStoreViewContent()}
      {type === 'store' && upperStoreViewContent()}
    </React.Fragment>
  );

  const upperEditDeliveryContent = () => (
    <React.Fragment>
      <Layout.FormGroup>
        <SociollaInput
          testID="modal-address-contact_person-input"
          isTransparent={true}
          label="Person in Charge (PIC)"
          name="contact_person"
          isRequired
          isUppercase
        />
      </Layout.FormGroup>
      <AddressToggle label="Premium" value="is_premium" />
      <AddressToggle label="Consignment" value="is_consignment" />
      {/* <Layout.FormGroup>
        <SociollaSelectBox
        isTransparent={true}
          label="Market Type"
          name="market_type"
          trackBy="id"
          labelKey="code"
          options={[]}
          editable={false}
          disabled
        />
      </Layout.FormGroup>
      <Layout.FormGroup>
        <SociollaSelectBox
        isTransparent={true}
          label="Business Type"
          name="business_type"
          trackBy="_id"
          labelKey="code"
          options={[]}
          editable={false}
          disabled
        />
      </Layout.FormGroup> */}
    </React.Fragment>
  );

  const renderAddressForm = () => (
    <React.Fragment>
      <SociollaText
        type="medium"
        style={{
          fontSize: 16,
          color: Colors.black2,
          marginBottom: 16,
          marginTop: 8,
        }}>
        Address
      </SociollaText>
      <Layout.FormGroup>
        <SociollaSelectBox
          testID="modal-address-country-select"
          isTransparent={true}
          label="Country ID"
          options={countries}
          value={country}
          name="country"
          trackBy="_id"
          labelKey="name"
          editable={false}
          disabled={true}
        />
      </Layout.FormGroup>
      <Layout.FormGroup>
        <SociollaSelectBox
          testID="modal-address-state-select"
          isTransparent={true}
          label={isVn() ? 'City ID' : 'State ID'}
          options={states}
          name="state"
          trackBy="_id"
          labelKey="name"
          onChange={onChangeState}
          isRequired
        />
      </Layout.FormGroup>
      <Layout.FormGroup>
        <SociollaSelectBox
          testID="modal-address-city-select"
          isTransparent={true}
          label={isVn() ? 'District Area' : 'City ID'}
          options={cities}
          name="city"
          trackBy="_id"
          labelKey="name"
          onChange={onChangeCity}
          editable={enableCity}
          disabled={!enableCity}
          isRequired
        />
      </Layout.FormGroup>
      {!isVn() && (
        <Layout.FormGroup>
          <SociollaSelectBox
            testID="modal-address-district-select"
            isTransparent={true}
            label="District"
            options={districts}
            name="district"
            trackBy="_id"
            labelKey="name"
            onChange={(val) => {
              form?.setFieldValue('postal_code', '');
              setSelectedDistrictPinCodes(val?.pin_codes || []);
            }}
            editable={enableDistrict}
            disabled={!enableDistrict}
            isRequired
          />
        </Layout.FormGroup>
      )}
      {!isVn() && selectedDistrictPinCodes.length > 0 ? (
        <Layout.FormGroup>
          <SociollaSelectBox
            testID="modal-address-postal_code-select"
            isTransparent={true}
            label="ZIP Code"
            name="postal_code"
            options={selectedDistrictPinCodes.map((code) => ({ code }))}
            trackBy="code"
            labelKey="code"
            isRequired
            onChange={(val) =>
              form?.setFieldValue('postal_code', val?.code || '')
            }
          />
        </Layout.FormGroup>
      ) : (
        <Layout.FormGroup>
          <SociollaInput
            testID="modal-address-postal_code-input"
            isTransparent={true}
            label="ZIP Code"
            name="postal_code"
            isRequired={!isVn()}
            keyboardType="numeric"
            isNumeric={true}
          />
        </Layout.FormGroup>
      )}
      <Layout.FormGroup>
        <SociollaInput
          testID="modal-address-street-input"
          isTransparent={true}
          label="Street"
          name="street"
          multiline={true}
          numberOfLines={2}
          isRequired
          isUppercase
        />
      </Layout.FormGroup>
      <Layout.FormGroup>
        <SociollaInput
          testID="modal-address-street2-input"
          isTransparent={true}
          label="Street 2"
          name="street2"
          multiline={true}
          numberOfLines={2}
          isUppercase
        />
      </Layout.FormGroup>
    </React.Fragment>
  );

  const renderAliasName = () => (
    <Layout.FormGroup>
      <SociollaInput
        testID="modal-address-name-input"
        isTransparent={true}
        label={props.modalType === 'delivery' ? 'Delivery Name' : 'Name'}
        name="name"
        isRequired
        isUppercase
      />
    </Layout.FormGroup>
  );

  const onToggleSameAsKtp = () => {
    const next = !sameAsKtp;
    setSameAsKtp(next);

    if (next) {
      setSameAsNpwp(false);
      applyAddressAutofill(ktp, {
        identityTargetField: type === 'npwp' ? 'vat' : null,
        identitySourceValue: ktp?.ktp,
      });
    } else {
      clearAutofilledAddress(type === 'npwp' ? 'vat' : null);
    }
  };

  const onToggleSameAsNpwp = () => {
    const next = !sameAsNpwp;
    setSameAsNpwp(next);

    if (next) {
      setSameAsKtp(false);
      applyAddressAutofill(npwp, {
        identityTargetField: type === 'ktp' ? 'ktp' : null,
        identitySourceValue: npwp?.vat,
      });
    } else {
      clearAutofilledAddress(type === 'ktp' ? 'ktp' : null);
    }
  };

  const renderAutofillCard = ({
    testID,
    checked,
    onToggle,
    title: cardTitle,
    uncheckedSubtitle,
    checkedSubtitle,
    style,
  }) => (
    <View
      style={[
        styles.autofillCard,
        checked ? styles.autofillCardChecked : styles.autofillCardUnchecked,
        style,
      ]}>
      <CheckBox
        testID={testID}
        checked={checked}
        checkboxContainerStyle={styles.autofillCheckboxRow}
        onChange={onToggle}>
        <View style={styles.autofillTextContainer}>
          <View style={styles.autofillTitleRow}>
            <SociollaText style={styles.autofillTitle}>
              {cardTitle}
            </SociollaText>
            {checked && (
              <SociollaText style={styles.autofillCopiedBadge}>
                {'✓'} Copied
              </SociollaText>
            )}
          </View>
          <SociollaText style={styles.autofillSubtitle}>
            {checked ? checkedSubtitle : uncheckedSubtitle}
          </SociollaText>
        </View>
      </CheckBox>
    </View>
  );

  const renderAutofillCheckboxes = () => {
    if (!showSameAsKtpCheckbox && !showSameAsNpwpCheckbox) {
      return null;
    }

    if (!isNotIdentity) {
      return (
        <Layout.FormGroup>
          {showSameAsKtpCheckbox &&
            renderAutofillCard({
              testID: `modal-address-${type}-same-as-ktp-checkbox`,
              checked: sameAsKtp,
              onToggle: onToggleSameAsKtp,
              title: 'Same as Identification Number (KTP) address',
              uncheckedSubtitle:
                'Fills all fields from your Identification Number (KTP) address',
              checkedSubtitle:
                'Address fields filled from Identification Number (KTP). You can still edit them.',
            })}
          {showSameAsNpwpCheckbox &&
            renderAutofillCard({
              testID: `modal-address-${type}-same-as-npwp-checkbox`,
              checked: sameAsNpwp,
              onToggle: onToggleSameAsNpwp,
              title: 'Same as Business Tax Code (NPWP) address',
              uncheckedSubtitle:
                'Fills address fields from your Business Tax Code (NPWP) address',
              checkedSubtitle:
                'Address fields filled from Business Tax Code (NPWP). You can still edit them.',
            })}
        </Layout.FormGroup>
      );
    }

    return (
      <Layout.FormGroup>
        <View style={styles.autofillTileRow}>
          {showSameAsKtpCheckbox &&
            renderAutofillCard({
              testID: `modal-address-${type}-same-as-ktp-checkbox`,
              checked: sameAsKtp,
              onToggle: onToggleSameAsKtp,
              title: 'Use Identification Number (KTP) address',
              uncheckedSubtitle: 'Copy fields from Identification Number (KTP)',
              checkedSubtitle:
                'Address fields filled from Identification Number (KTP). You can still edit them.',
              style: [
                styles.autofillTile,
                showSameAsNpwpCheckbox && styles.autofillTileSpacing,
              ],
            })}
          {showSameAsNpwpCheckbox &&
            renderAutofillCard({
              testID: `modal-address-${type}-same-as-npwp-checkbox`,
              checked: sameAsNpwp,
              onToggle: onToggleSameAsNpwp,
              title: 'Use Business Tax Code (NPWP) address',
              uncheckedSubtitle: 'Copy fields from Business Tax Code (NPWP)',
              checkedSubtitle:
                'Address fields filled from Business Tax Code (NPWP). You can still edit them.',
              style: styles.autofillTile,
            })}
        </View>
      </Layout.FormGroup>
    );
  };

  const renderInputKTP = () => (
    <SociollaInput
      testID="modal-address-ktp-input"
      isTransparent={true}
      label={isVn() ? 'Identification Number' : 'Identification Number (KTP)'}
      placeholder={isVn() ? 'e.g. 123456789012' : '317xxxxxxxxxxxxx'}
      name="ktp"
      autoComplete="off"
      isRequired
      isKTP={true}
    />
  );

  const renderStoreCode = () => (
    <React.Fragment>
      <Layout.FormGroup>
        <SociollaInput
          testID="modal-address-store_code-input"
          isTransparent={true}
          label="Store Code"
          name="store_code"
          isRequired
          isUppercase
        />
      </Layout.FormGroup>
      <AddressToggle label="Premium" value="is_premium" />
    </React.Fragment>
  );

  const renderInputNPWP = () => (
    <SociollaInput
      testID="modal-address-vat-input"
      isTransparent={true}
      label={
        isVn()
          ? 'Tax Identification Number'
          : 'Tax Identification Number (NPWP)'
      }
      placeholder={isVn() ? 'e.g. 123456789012345' : 'e.g. 233451231283453'}
      name="vat"
      autoComplete="off"
      isRequired
      isNPWP={true}
    />
  );

  const upperIdentityEditContent = () => (
    <Layout.FormGroup>
      {type === 'ktp' && renderInputKTP()}
      {type === 'npwp' && renderInputNPWP()}
    </Layout.FormGroup>
  );

  const renderUpperEditContent = () => (
    <React.Fragment>
      {renderAutofillCheckboxes()}
      {renderAliasName()}
      {type === 'delivery' && upperEditDeliveryContent()}
      {isNotIdentity && type !== 'store' && renderAddressForm()}
      {!isNotIdentity && type !== 'store' && upperIdentityEditContent()}
      {type === 'store' && renderStoreCode()}
    </React.Fragment>
  );

  /**
   * render top or left section content
   */
  const renderTopContent = () => (
    <View style={[styles.oneFlex, { marginBottom: isWeb && isView ? 30 : 0 }]}>
      {isView && renderUpperViewContent()}
      {!isView && renderUpperEditContent()}
    </View>
  );

  const renderSeparator = () => <View style={styles.separator} />;

  const lowerViewNonIdentity = () => (
    <React.Fragment>
      <ItemDetail name="Email" value={props.data?.email || '-'} />
      <ItemDetail name="Phone" value={props.data?.phone || '-'} />
      <ItemDetail name="Mobile" value={props.data?.mobile || '-'} />
      <ItemDetail name="Notes" value={props.data?.notes || '-'} />
    </React.Fragment>
  );

  const lowerViewLocation = () =>
    props.data?.lat_long?.latitude && props.data?.lat_long?.longitude ? (
      <ItemDetail
        name="Location"
        style={{ flexDirection: 'column' }}
        valueComponent={
          <SociollaMapPicker
            disabled={true}
            editable={false}
            hideInput={true}
            value={props.data.lat_long}
            containerStyle={{
              marginTop: 14,
              borderRadius: 4,
              width: '100%',
            }}
          />
        }
      />
    ) : (
      <ItemDetail
        name="Location"
        style={{ justifyContent: 'flex-start' }}
        valueComponent={
          <View style={{ flexDirection: 'column' }}>
            <View
              style={{
                flexDirection: 'row',
                marginBottom: 6,
              }}>
              <Image
                style={{ width: 14, height: 14 }}
                width={14}
                height={14}
                svg={true}
                source={require('@assets/img/icons/attention-red.svg')}
              />
              <SociollaText
                style={{
                  marginLeft: 8,
                  fontSize: 12,
                  color: Colors.red3,
                }}>
                Address pinpoint not set
              </SociollaText>
            </View>
            <SociollaText
              style={{
                marginLeft: 24,
                fontSize: 10,
                color: Colors.black3,
              }}>
              Edit address to add pinpoint location
            </SociollaText>
          </View>
        }
      />
    );

  const lowerStoreCode = () => (
    <ItemDetail name="Store Code" value={props.data?.store_code || '-'} />
  );

  const lowerInvoiceSchedule = () => (
    <>
      <SociollaText
        type="medium"
        style={{
          fontSize: 12,
          letterSpacing: 0.5,
          textAlign: 'left',
          marginTop: 50,
          marginBottom: 10,
        }}>
        Invoicing Schedule
      </SociollaText>
      <ItemDetail name="Day" value={renderDayValue(props.data)} />
      <ItemDetail name="Time" value={renderTimeValue(props.data)} />
    </>
  );

  const lowerNonStoreViewContent = () => (
    <React.Fragment>
      {isNotIdentity && lowerViewNonIdentity()}
      {!isNotIdentity && renderViewAddress()}
      {type === 'delivery' && lowerStoreCode()}
      {type === 'delivery' && lowerViewLocation()}
      {type === 'invoice' && lowerInvoiceSchedule()}
    </React.Fragment>
  );

  const lowerStoreViewContent = () => (
    <React.Fragment>
      {isWeb && (
        <SociollaText
          type="medium"
          style={{
            fontSize: 14,
            letterSpacing: 0.5,
            textAlign: 'left',
            marginBottom: 12,
          }}>
          Address
        </SociollaText>
      )}
      <ItemDetail name="Country ID" value={props.data?.country?.name || '-'} />
      <ItemDetail
        name={isVn() ? 'City ID' : 'State ID'}
        value={props.data?.state?.name || '-'}
      />
      <ItemDetail
        name={isVn() ? 'District Area' : 'City ID'}
        value={props.data?.city?.name || '-'}
      />
      {!isVn() && (
        <ItemDetail name="District" value={props.data?.district?.name || '-'} />
      )}
      <ItemDetail name="ZIP Code" value={props.data?.postal_code || '-'} />
      <ItemDetail name="Street" value={props.data?.street || '-'} />
      <ItemDetail name="Street 2" value={props.data?.street2 || '-'} />
      {lowerViewLocation()}
    </React.Fragment>
  );

  const renderLowerViewContent = () => (
    <React.Fragment>
      {type !== 'store' && lowerNonStoreViewContent()}
      {type === 'store' && lowerStoreViewContent()}
    </React.Fragment>
  );

  const lowerEditDeliveryForm = () => (
    <React.Fragment>
      <Layout.FormGroup>
        <SociollaMapPicker
          testID="modal-address-lat_long-map"
          label="Location"
          name="lat_long"
          hideInput={true}
          onCurrentLocation={
            props.data?.lat_long?.latitude && props.data?.lat_long?.longitude
              ? props.data.lat_long
              : onCurrentLocation
          }
          onChangeAddress={(val) => {
            if (states?.length && val.state) {
              const st = states.find(
                (a) => a.name && findMatchValue(a.name, val.state),
              );
              if (st) {
                form.setFieldValue('state', st);
              }
            }
          }}
          containerStyle={{ width: '100%' }}
        />
      </Layout.FormGroup>
    </React.Fragment>
  );
  const lowerEditStoreCodeDeliveryForm = () => (
    <React.Fragment>
      <Layout.FormGroup>
        <SociollaInput
          testID="modal-address-delivery-store_code-input"
          isTransparent={true}
          label="Store Code"
          name="store_code"
        />
      </Layout.FormGroup>
    </React.Fragment>
  );

  const lowerEditBioGraphicForm = () => (
    <React.Fragment>
      <Layout.FormGroup>
        <SociollaInput
          testID="modal-address-email-input"
          isTransparent={true}
          label="Email"
          name="email"
        />
      </Layout.FormGroup>
      <Layout.FormGroup>
        <SociollaInput
          testID="modal-address-phone-input"
          isTransparent={true}
          isNumeric
          label="Phone"
          name="phone"
          keyboardType="numeric"
        />
      </Layout.FormGroup>
      <Layout.FormGroup>
        <SociollaInput
          testID="modal-address-mobile-input"
          isTransparent={true}
          isNumeric
          label="Mobile"
          name="mobile"
          isRequired
          keyboardType="numeric"
        />
      </Layout.FormGroup>
      {/* <Layout.FormGroup>
        <SociollaFileImage
          label="Upload Photo"
          placeholderImage={require('@assets/img/icons/add-image-grey.svg')}
          name="image"
        />
      </Layout.FormGroup> */}
      <Layout.FormGroup>
        <SociollaInput
          testID="modal-address-notes-input"
          isTransparent={true}
          label="Notes"
          name="notes"
          multiline={true}
          numberOfLines={4}
          isUppercase
        />
      </Layout.FormGroup>
    </React.Fragment>
  );

  const renderLowerEditStoreForm = () => (
    <React.Fragment>
      {isWeb && (
        <Layout.FormGroup>
          <SociollaText
            type="medium"
            style={{
              fontSize: 14,
              letterSpacing: 0.5,
              textAlign: 'left',
              marginBottom: 12,
            }}>
            Address
          </SociollaText>
        </Layout.FormGroup>
      )}
      <Layout.FormGroup>
        <SociollaSelectBox
          testID="modal-address-store-country-select"
          isTransparent={true}
          label="Country ID"
          options={countries}
          value={country}
          name="country"
          trackBy="_id"
          labelKey="name"
          editable={false}
          disabled={true}
        />
      </Layout.FormGroup>
      <Layout.FormGroup>
        <SociollaSelectBox
          testID="modal-address-store-state-select"
          isTransparent={true}
          label={isVn() ? 'City ID' : 'State ID'}
          options={states}
          name="state"
          trackBy="_id"
          labelKey="name"
          onChange={onChangeState}
          isRequired
        />
      </Layout.FormGroup>
      <Layout.FormGroup>
        <SociollaSelectBox
          testID="modal-address-store-city-select"
          isTransparent={true}
          label={isVn() ? 'District Area' : 'City ID'}
          options={cities}
          name="city"
          trackBy="_id"
          labelKey="name"
          onChange={onChangeCity}
          editable={enableCity}
          disabled={!enableCity}
          isRequired
        />
      </Layout.FormGroup>
      {!isVn() && (
        <Layout.FormGroup>
          <SociollaSelectBox
            testID="modal-address-store-district-select"
            isTransparent={true}
            label="District"
            options={districts}
            name="district"
            trackBy="_id"
            labelKey="name"
            onChange={(val) => {
              form?.setFieldValue('postal_code', '');
              setSelectedDistrictPinCodes(val?.pin_codes || []);
            }}
            editable={enableDistrict}
            disabled={!enableDistrict}
            isRequired
          />
        </Layout.FormGroup>
      )}
      {!isVn() && selectedDistrictPinCodes.length > 0 ? (
        <Layout.FormGroup>
          <SociollaSelectBox
            testID="modal-address-store-postal_code-select"
            isTransparent={true}
            label="ZIP Code"
            name="postal_code"
            options={selectedDistrictPinCodes.map((code) => ({ code }))}
            trackBy="code"
            labelKey="code"
            isRequired
            onChange={(val) =>
              form?.setFieldValue('postal_code', val?.code || '')
            }
          />
        </Layout.FormGroup>
      ) : (
        <Layout.FormGroup>
          <SociollaInput
            testID="modal-address-store-postal_code-input"
            isTransparent={true}
            label="ZIP Code"
            name="postal_code"
            isRequired={!isVn()}
            keyboardType="numeric"
            isNumeric={true}
          />
        </Layout.FormGroup>
      )}
      <Layout.FormGroup>
        <SociollaInput
          testID="modal-address-store-street-input"
          isTransparent={true}
          label="Street"
          name="street"
          multiline={true}
          numberOfLines={2}
          isRequired
          isUppercase
        />
      </Layout.FormGroup>
      <Layout.FormGroup>
        <SociollaInput
          testID="modal-address-store-street2-input"
          isTransparent={true}
          label="Street 2"
          name="street2"
          multiline={true}
          numberOfLines={2}
          isUppercase
        />
      </Layout.FormGroup>
      <Layout.FormGroup>
        <SociollaMapPicker
          testID="modal-address-store-lat_long-map"
          label="Location"
          name="lat_long"
          hideInput={true}
          onCurrentLocation={
            props.data?.lat_long?.latitude && props.data?.lat_long?.longitude
              ? props.data.lat_long
              : onCurrentLocation
          }
          onChangeAddress={(val) => {
            if (states?.length && val.state) {
              const st = states.find(
                (a) => a.name && findMatchValue(a.name, val.state),
              );
              if (st) {
                form.setFieldValue('state', st);
              }
            }
          }}
          containerStyle={{ width: '100%' }}
        />
      </Layout.FormGroup>
    </React.Fragment>
  );

  const renderLowerEditNonIdentity = () => (
    <React.Fragment>
      {type !== 'store' && lowerEditBioGraphicForm()}
      {type === 'delivery' && lowerEditDeliveryForm()}
      {type === 'delivery' && lowerEditStoreCodeDeliveryForm()}
      {type === 'store' && renderLowerEditStoreForm()}
    </React.Fragment>
  );

  const renderInvoicingScheduleTitle = () => (
    <SociollaText
      type="medium"
      style={{
        fontSize: 12,
        letterSpacing: 0.5,
        textAlign: 'left',
        marginBottom: 12,
      }}>
      Invoicing Schedule
    </SociollaText>
  );

  const renderDaySelector = () => (
    <View>
      <SociollaText
        style={{
          fontSize: 12,
          letterSpacing: 0.5,
          textAlign: 'left',
          marginBottom: 12,
        }}>
        Select Day
      </SociollaText>
      <View>
        <CheckBox
          testID="modal-address-list_day-checkbox"
          isManualContext={true}
          isManualError={true}
          options={optionDays}
          labelKey="list_day"
          trackBy="value"
          isMultiple={true}
          totalColumn={isWeb ? 2 : 1}
          value={form?.values?.list_day || []}
          onChange={(value) => {
            form.setFieldValue('list_day', value);
          }}
        />
      </View>
    </View>
  );

  const renderTimeLabel = () => (
    <View>
      <SociollaText
        style={{
          marginTop: 20,
          fontSize: 12,
          letterSpacing: 0.5,
          textAlign: 'left',
          marginBottom: 12,
        }}>
        Select Time
      </SociollaText>
    </View>
  );

  const renderTimeSelectors = () => {
    const fromTime = form?.values?.from_time || '';
    const toTime = form?.values?.to_time || '';

    return (
      <View
        style={{
          width: '100%',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}>
        <View style={{ width: '48%' }}>
          <TimePicker
            testID="modal-address-from_time-picker"
            label="From"
            value={fromTime}
            isRequired
            onChange={(value) => form.setFieldValue('from_time', value)}
            isManualError={true}
          />
        </View>
        <View style={{ width: '48%' }}>
          <TimePicker
            testID="modal-address-to_time-picker"
            label="To"
            value={toTime}
            isRequired
            onChange={(value) => form.setFieldValue('to_time', value)}
            isManualError={true}
          />
        </View>
      </View>
    );
  };

  const renderTimePicker = () => (
    <View
      style={{
        marginTop: 20,
        marginLeft: 8,
        marginBottom: isWeb ? 30 : 10,
        paddingBottom: 30,
      }}>
      {renderInvoicingScheduleTitle()}
      {renderDaySelector()}
      {renderTimeLabel()}
      {renderTimeSelectors()}
    </View>
  );

  const renderLowerEditContent = () => (
    <React.Fragment>
      {isNotIdentity && renderLowerEditNonIdentity()}
      {!isNotIdentity && renderAddressForm()}
      {type === 'invoice' && renderTimePicker()}
    </React.Fragment>
  );

  /**
   * render bottom or left section content
   */
  const renderBottomContent = () => (
    <View style={styles.oneFlex}>
      {isView && renderLowerViewContent()}
      {!isView && renderLowerEditContent()}
      {!isWeb && <View style={{ height: 80 }}></View>}
    </View>
  );

  const renderSeparatorLine = () => <View style={styles.separatorLine} />;

  const renderFormContent = () => (
    <View>
      {isWeb && renderSeparatorLine()}
      <View
        style={[
          styles.container,
          styles.containerPadding,
          {
            paddingBottom: isWeb ? 0 : 56,
            // marginTop: isWeb && isView && !isNotIdentity ? 15 : 0,
          },
        ]}>
        {renderTopContent()}
        {isWeb && renderSeparator()}
        {renderBottomContent()}
      </View>
    </View>
  );

  const renderContent = () => (
    <Layout.KeyboardWrapper
      style={isWeb ? { maxHeight: dimension.height - 300 } : {}}>
      {/* {isView && isNotIdentity && renderImageAddress()} */}
      {renderFormContent()}
    </Layout.KeyboardWrapper>
  );

  const renderTextButton = () => (
    <SociollaText
      type="bold"
      style={{
        fontSize: 14,
        letterSpacing: 0.5,
        color: Colors.white,
        textAlign: 'center',
      }}>
      {props.edit ? 'Update Address' : 'Save Address'}
    </SociollaText>
  );

  const renderSociollaButton = (stylesContainerButton) => (
    <View style={stylesContainerButton}>
      <SociollaSubmitButton
        testID="modal-address-submit-btn"
        buttonStyle={{
          ...buttonRounded,
          width: isWeb ? 300 : '100%',
          marginBottom: !isWeb ? 30 : 0,
        }}
        title={renderTextButton()}
      />
    </View>
  );

  const renderBlankSpaces = () => <View style={{ height: 24 }} />;

  const getStylesButtons = () => {
    const buttonWebStyles = {
      marginTop: 20,
      justifyContent: 'center',
      alignItems: 'center',
    };
    const buttonDeviceStyles = {
      position: 'absolute',
      bottom: 0,
      width: '100%',
      backgroundColor: Colors.white,
    };
    const stylesContainerButton = [
      isWeb ? buttonWebStyles : buttonDeviceStyles,
      styles.containerPadding,
    ];

    return stylesContainerButton;
  };

  const _getFormProps = () => ({
    initialValues: initialValue,
    onSubmit: handleSubmit,
    validationSchema: validationForm,
    innerRef: (formik) => (form = formik),
  });

  const _getModalProps = () => ({
    testID: props.testID,
    show: props.show,
    title: title,
    width: isWeb ? 900 : '100%',
    onClose: onClose,
    closeOutside: isView ? true : false,
  });

  const renderButton = () => {
    const propsButton = getStylesButtons();

    return isView ? renderBlankSpaces() : renderSociollaButton(propsButton);
  };

  const renderModalForm = () => (
    <SociollaForm {..._getFormProps()}>
      {renderContent()}
      {renderButton()}
    </SociollaForm>
  );

  return (
    <ModalFull {..._getModalProps()}>
      {loading && renderLoading()}
      {!loading && renderModalForm()}
      <Alert />
    </ModalFull>
  );
};

const styles = StyleSheet.create({
  autofillCard: {
    borderRadius: 6,
    padding: 12,
    marginBottom: 8,
  },
  autofillCardUnchecked: {
    backgroundColor: Colors.blue12,
  },
  autofillCardChecked: {
    backgroundColor: Colors.green0,
  },
  autofillCheckboxRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginRight: 0,
    width: '100%',
  },
  autofillTextContainer: {
    flex: 1,
  },
  autofillTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  autofillTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: Colors.blue0,
  },
  autofillCopiedBadge: {
    fontSize: 12,
    fontWeight: '600',
    color: Colors.green1,
    marginLeft: 8,
  },
  autofillSubtitle: {
    fontSize: 12,
    color: Colors.black3,
    marginTop: 2,
  },
  autofillTileRow: {
    flexDirection: 'row',
  },
  autofillTile: {
    flex: 1,
  },
  autofillTileSpacing: {
    marginRight: 10,
  },
  container: {
    flexDirection: isWeb ? 'row' : 'column',
    width: '100%',
  },
  containerPadding: {
    paddingVertical: 15,
    paddingHorizontal: 25,
  },
  separator: {
    height: '100%',
    width: 1,
    backgroundColor: Colors.grey9,
    marginHorizontal: 30,
  },
  oneFlex: { flex: 1 },
  separatorLine: {
    borderBottomWidth: 1,
    borderBottomColor: Colors.grey0,
    width: '95%',
    marginTop: 20,
    marginLeft: 24,
  },
});

ModalAddress.propTypes = propTypes;

export default ModalAddress;
